/* ICExtract theme JS — vanilla, no dependencies.
   Handles: mobile nav drawer (focus trap + Escape), newsletter client validation. */
(function () {
  'use strict';

  /* ---------------- Mobile drawer ---------------- */
  var drawer = document.querySelector('[data-ic-drawer]');
  var backdrop = document.querySelector('[data-ic-drawer-backdrop]');
  var openBtn = document.querySelector('[data-ic-drawer-open]');
  var closeBtn = document.querySelector('[data-ic-drawer-close]');
  var lastFocused = null;

  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      ),
      function (el) {
        return el.offsetParent !== null;
      }
    );
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    backdrop.hidden = false;
    // Force reflow so transitions run
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var els = focusables(drawer);
    if (els.length) els[0].focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    window.setTimeout(function () {
      drawer.hidden = true;
      backdrop.hidden = true;
    }, 260);
    if (lastFocused) lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    // Trap focus inside the drawer
    var els = focusables(drawer);
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  if (openBtn && drawer && backdrop) {
    openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
  }

  /* ---------------- Newsletter validation ---------------- */
  var newsletter = document.querySelector('[data-ic-newsletter], #ICFooterNewsletter');
  if (newsletter) {
    newsletter.addEventListener('submit', function (e) {
      var input = newsletter.querySelector('input[type="email"]');
      if (!input) return;
      var value = (input.value || '').trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!valid) {
        e.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        var existing = newsletter.querySelector('.ic-newsletter__message--client-error');
        if (!existing) {
          var msg = document.createElement('p');
          msg.className = 'ic-newsletter__message ic-newsletter__message--error ic-newsletter__message--client-error';
          msg.setAttribute('role', 'alert');
          msg.textContent = 'Please enter a valid email address.';
          newsletter.appendChild(msg);
        }
      } else {
        input.removeAttribute('aria-invalid');
        var err = newsletter.querySelector('.ic-newsletter__message--client-error');
        if (err) err.remove();
      }
    });
  }
})();
